import { DatePipe } from '@angular/common';

const DATE_ONLY = /^(\d{4})-(\d{2})-(\d{2})$/;

/**
 * Calendar day from a saved-report date.
 * "yyyy-MM-dd" is a date, not a UTC instant. new Date("yyyy-MM-dd") is UTC
 * midnight and shows the previous day in timezones behind UTC.
 * The year, month, and day are taken from the string. The Date is built with
 * those fields so date pickers show that same day in every timezone.
 */
export function toCalendarDate(value: any): Date | null {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  if (value instanceof Date) {
    return isNaN(value.getTime()) ? null : value;
  }

  const match = DATE_ONLY.exec(String(value).trim());
  if (!match) {
    const parsed = new Date(value);
    return isNaN(parsed.getTime()) ? null : parsed;
  }

  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  const date = new Date(year, month - 1, day);
  if (
    date.getFullYear() !== year ||
    date.getMonth() !== month - 1 ||
    date.getDate() !== day
  ) {
    return null;
  }

  return date;
}

/**
 * Writes the calendar day the picker shows. Does not convert through a timezone.
 */
export function formatCalendarDate(value: any, format: string = 'yyyy-MM-dd'): string {
  const date = toCalendarDate(value);
  if (!date) {
    return '';
  }

  const pipe = new DatePipe('en-US');
  return pipe.transform(new Date(date.getFullYear(), date.getMonth(), date.getDate()), format) || '';
}
